/* eslint-disable no-console */
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomModal from "../../../Core/Components/Modal/CustomModal";
import CloseIcon from "../../../Common/Svgs/CloseIcon";
import TickIcon from "../../../Common/Svgs/TickIcon";
import { updateTrips } from "../../../Redux/Slices/trips.slice";
import { RECEIPT_STATUS } from "../Data/TripConstants";
import { client } from "../../../Utils/axiosClient";
import {
  getCurrentTripStatus,
  getStopSummary,
} from "../../../Redux/APIs/tripsAPI";

const ViewReceiptModal = ({ visible, onCancel }) => {
  const dispatch = useDispatch();

  const { toastMessage, receiptModal, currentStop } = useSelector(
    (state) => state.trips,
  );

  const stopMetaDataFromOverallSummary = receiptModal?.data?.metaData;

  const handleReceiptVerification = async () => {
    try {
      await client.put(
        `${process.env.REACT_APP_API_URL}/trip/update-receipt-status`,
        {
          activityId: receiptModal?.data?.activityId,
          status: RECEIPT_STATUS.VERIFIED,
        },
      );

      await dispatch(
        getStopSummary({
          tripId: currentStop.tripId,
          stopId: currentStop.stopId,
        }),
      );

      // to update the status tag of current trip
      await dispatch(getCurrentTripStatus({ tripId: currentStop.tripId }));

      onCancel();
      // toast message for success
      dispatch(
        updateTrips({
          key: "toastMessage",
          value: {
            ...toastMessage,
            visible: true,
            type: "receiptVerified",
          },
        }),
      );
    } catch (error) {
      console.error("Error updating receipt status:", error);
    }
  };

  return (
    <CustomModal visible={visible} onCancel={onCancel} width="536px">
      <div
        className="rounded-xl overflow-hidden"
        style={{
          boxShadow:
            "12px 12px 16px -4px rgba(16, 24, 40, 0.08), -4px -4px 6px -2px rgba(16, 24, 40, 0.03)",
        }}
      >
        <div className="flex items-center justify-between pl-4 pt-4 pb-6 pr-6">
          <div className="flex items-center gap-x-3">
            <div className="w-12 h-12 bg-primary flex items-center justify-center rounded-full">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M22 6V8.42C22 10 21 11 19.42 11H16V4.01C16 2.9 16.91 2 18.02 2C19.11 2.01 20.11 2.45 20.83 3.17C21.55 3.9 22 4.9 22 6Z"
                  stroke="#FAFAFA"
                  strokeWidth="1.5"
                  strokeMiterlimit="10"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M2 7V21C2 21.83 2.93998 22.3 3.59998 21.8L5.31 20.52C5.71 20.22 6.27 20.26 6.63 20.62L8.28998 22.29C8.67998 22.68 9.32002 22.68 9.71002 22.29L11.39 20.61C11.74 20.26 12.3 20.22 12.69 20.52L14.4 21.8C15.06 22.29 16 21.82 16 21V4C16 2.9 16.9 2 18 2H7H6C3 2 2 3.79 2 6V7Z"
                  stroke="#FAFAFA"
                  strokeWidth="1.5"
                  strokeMiterlimit="10"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M6 9H12"
                  stroke="#FAFAFA"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M6.75 13H11.25"
                  stroke="#FAFAFA"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>

            <div>
              <p className="font-poppins text-base font-medium">Receipt</p>
              <p className="font-aileron font-normal text-xs text-dark-gray">
                {stopMetaDataFromOverallSummary?.receiptId}
              </p>
            </div>

            {stopMetaDataFromOverallSummary?.receiptStatus ===
              RECEIPT_STATUS.VERIFIED && (
              <div className="flex bg-green-10 px-2 py-1 rounded-4">
                <TickIcon size={16} className="h-4 w-4 mr-2 text-primary" />
                <p className="font-poppins font-medium text-xs text-primary">
                  Verified
                </p>
              </div>
            )}
          </div>

          <button type="button" className="mr-2" onClick={onCancel}>
            <CloseIcon className="w-6 h-6 stroke-dark-gray" />
          </button>
        </div>

        <div className="bg-light-grey flex items-center justify-center p-4">
          <div className="w-full h-[334px]">
            {stopMetaDataFromOverallSummary?.receiptUrl ? (
              <img
                src={stopMetaDataFromOverallSummary?.receiptUrl}
                className="w-full h-full object-contain"
                alt="id"
              />
            ) : (
              <p className="py-[130px] sfont-poppins font-medium text-sm text-center">
                Preview Unavailable
              </p>
            )}
          </div>
        </div>
        {stopMetaDataFromOverallSummary?.receiptStatus ===
        RECEIPT_STATUS.VERIFIED ? null : (
          <div className="flex items-center justify-end pl-4 pt-4 pb-6 pr-6">
            <button type="button" className="mr-3 px-4 py-3" onClick={onCancel}>
              <p className="font-poppins font-medium text-xs">Close</p>
            </button>
            <button
              type="button"
              className=" w-fit flex bg-primary rounded-md py-3 px-4 text-background-white gap-x-[1px] items-center"
              onClick={handleReceiptVerification}
            >
              <TickIcon size={16} className="h-4 w-4 mr-2" />
              <p className="font-poppins font-medium text-xs ">
                Verify Receipt
              </p>
            </button>
          </div>
        )}
      </div>
    </CustomModal>
  );
};

export default ViewReceiptModal;
